<script>
  import { TimePicker } from "carbon-components-svelte";
  import { TextInput } from "paxray-components-svelte";

  export let subActivityToEdit = {
    id: "",
    subActivityName: "",
    subActivityExpense: "",
    subActivityStart: "",
    subActivityEnd: "",
    subActivityDate: "",
    activityId: null,
  };
  const timePattern = /^([01]\d|2[0-3]):([0-5]\d)$/;
  let invalidBeginn = false;
  let invalidEnde = false;

  $: {
    subActivityToEdit.subActivityExpense = calculateExpense(
      subActivityToEdit.subActivityStart,
      subActivityToEdit.subActivityEnd,
    );
  }

  $: {
    invalidBeginn =
      !timePattern.test(subActivityToEdit.subActivityStart) &&
      subActivityToEdit.subActivityStart !== "hh:mm";
    invalidEnde =
      !timePattern.test(subActivityToEdit.subActivityEnd) &&
      subActivityToEdit.subActivityEnd !== "hh:mm";
  }

  function isValidTime(start, end) {
    return start.match(timePattern) && end.match(timePattern);
  }

  function calculateExpense(start, end) {
    if (!start || !end) {
      return "-";
    }
    if (isValidTime(start, end)) {
      const [startHour, startMinute] = start.split(":").map(Number);
      const [endHour, endMinute] = end.split(":").map(Number);

      let totalMinutes =
        endHour * 60 + endMinute - (startHour * 60 + startMinute);
      if (totalMinutes < 0) {
        totalMinutes += 24 * 60;
      }
      const hours = Math.floor(totalMinutes / 60);
      const minutes = totalMinutes % 60;
      return `${hours}h ${minutes}min`;
    } else {
      return "-";
    }
  }
</script>

<form id="subActivityForm">
  <div class="form-grid">
    <div>
      <TextInput
        label="Name"
        id="name"
        placeholder={subActivityToEdit.subActivityName}
        required
        bind:value={subActivityToEdit.subActivityName}
      />
    </div>
    <TextInput
      date={true}
      label="Datum"
      id="datum"
      placeholder={subActivityToEdit.subActivityDate}
      bind:value={subActivityToEdit.subActivityDate}
    />
    <div style="display: flex; align-items: center; gap: 1rem;">
      <div class="time-picker">
        <label for="Beginn">Beginn</label>
        <TimePicker
          placeholder="hh:mm"
          label="Beginn"
          size="sm"
          light
          bind:value={subActivityToEdit.subActivityStart}
          on:change={() => {}}
          pattern={timePattern}
          invalid={invalidBeginn}
        />
      </div>
      <div class="time-picker">
        <label for="Ende">Ende</label>
        <TimePicker
          placeholder="hh:mm"
          label="Ende"
          size="sm"
          light
          bind:value={subActivityToEdit.subActivityEnd}
          on:change={() => {}}
          pattern={timePattern}
          invalid={invalidEnde}
        />
      </div>
    </div>
    <TextInput
      label="Aufwand"
      id="protocol"
      unChanged
      value={subActivityToEdit.subActivityExpense}
    />
  </div>
</form>

<style>
  label {
    display: block;
    margin-bottom: 0.5rem;
    font-size: 0.875rem;
    font-weight: 700;
    color: #1f2937;
  }

  .form-grid {
    display: grid;
    gap: 1rem;
    margin-bottom: 1.5rem;
    margin-top: 1.5rem;
    grid-template-columns: repeat(2, 1fr);
  }

  :global(.time-picker .bx--time-picker__input-field) {
    padding-right: 10px;
    padding-left: 10px;
    width: 65px;
  }

  :global(.time-picker .bx--form-item) {
    align-items: center;
    justify-content: center;
    width: 65px;
  }

  :global(.time-picker .bx--text-input--invalid) {
    border-color: red;
  }
</style>
